<template>
  <span v-if="workingQualifier">
    <v-row>
      <v-col cols="12">
        <v-select label="ACH Transaction Type" outlined dense :items="Object.entries(AchTransactionTypes)"
          v-model="workingQualifier.transactionType" item-text="1" item-value="0" :rules="requiredRule"
          @input="onChange" ref="achTransactionTypeSelector"/>
      </v-col>
    </v-row>
    <v-row v-if="isAchTypeSplittable()">
      <v-col cols="12">
        <v-checkbox
          label="Split Count?"
          v-model="workingQualifier.splitCounts"
          dense
          hide-details
          @change="onChange"
          ref="splitCheckBox"/>
      </v-col>
    </v-row>

    <template v-if="isAchTypeSplittable() && workingQualifier.splitCounts">
      <template v-if="workingQualifier.transactionType.includes('DEBIT')">
        <v-row class="mt-8">
          <v-col cols="12">
            <v-text-field
              label="ACH Debit Count"
              v-model="workingQualifier.minTransactionCountAchDebit"
              type="number"
              hint="Ex. 2"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="minTransactionCountAchDebit"
            />
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="12">
            <v-text-field
              label="ACH Debit Minimum Amount"
              v-model="workingQualifier.minTransactionAmountAchDebit"
              type="number"
              hint="Ex. 5.00"
              prefix="$"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="minTransactionAmountAchDebit"
            />
          </v-col>
        </v-row>
      </template>

      <template v-if="workingQualifier.transactionType.includes('CREDIT')">
        <v-row class="mt-8">
          <v-col cols="12">
            <v-text-field
              label="ACH Credit Count"
              v-model="workingQualifier.minTransactionCountAchCredit"
              type="number"
              hint="Ex. 2"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="minTransactionCountAchCredit"
            />
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="12">
            <v-text-field
              label="ACH Credit Minimum Amount"
              v-model="workingQualifier.minTransactionAmountAchCredit"
              type="number"
              hint="Ex. 5.00"
              prefix="$"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="minTransactionAmountAchCredit"
            />
          </v-col>
        </v-row>
      </template>

      <template v-if="workingQualifier.transactionType.includes('BILL_PAY')">
        <v-row class="mt-8">
          <v-col cols="12">
            <v-text-field
              label="Bill Pay Count"
              v-model="workingQualifier.minTransactionCountBillPay"
              type="number"
              hint="Ex. 2"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="minTransactionCountBillPay"
            />
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="12">
            <v-text-field
              label="Bill Pay Minimum Amount"
              v-model="workingQualifier.minTransactionAmountBillPay"
              type="number"
              hint="Ex. 5.00"
              prefix="$"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="minTransactionAmountBillPay"
            />
          </v-col>
        </v-row>
      </template>
    </template>

    <template v-else-if="workingQualifier.transactionType">
      <v-row class="mt-8">
          <v-col cols="12">
            <v-text-field
              label="Transaction Count"
              v-model="workingQualifier.globalMinimumTransactionCount"
              type="number"
              hint="Ex. 2"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="globalMinimumTransactionCount"
            />
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="12">
            <v-text-field
              label="Minimum Amount"
              v-model="workingQualifier.globalMinimumTransactionAmount"
              type="number"
              hint="Ex. 5.00"
              prefix="$"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="globalMinimumTransactionAmount"
            />
          </v-col>
        </v-row>
    </template>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { AchQualifier } from '@/api/product/levelrewards/qualifiers';
import { AchTransactionTypes } from '@/api/product/levelrewards';
import { ValidationTool } from '@/util';

@Component
export default class AchQualifierEditor extends Vue {
  @Prop()
  value!:AchQualifier;

  workingQualifier:AchQualifier | null = null;

  requiredRule:Array<any> = [(value: any) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  // Make visible to the template
  AchTransactionTypes: any = AchTransactionTypes;

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingQualifier = this.value.clone() as AchQualifier;
  }

  onChange() {
    this.$emit('input', this.workingQualifier);
  }

  isAchTypeSplittable():boolean {
    let splittable = false;
    const transactionType = this.workingQualifier!.transactionType;
    splittable = (transactionType === 'ACH_DEBIT_OR_ACH_CREDIT'
        || transactionType === 'ACH_DEBIT_OR_BILL_PAY'
        || transactionType === 'ACH_CREDIT_OR_BILL_PAY'
        || transactionType === 'ACH_DEBIT_OR_ACH_CREDIT_OR_BILL_PAY');
    return splittable;
  }
}
</script>

<style lang="scss" scoped>
</style>
